import i18n from '@/utils/i18n';
import {
  EMPTY_VALUE_PLACEHOLDER,
  MANAGER_FORECAST_WINDOWS_IN_DAYS,
} from '@/experiences/sales-portal/domain/prospects/screens/prospects/constants';
import { formatCurrency } from '@/utils/money';
import { ManagerForecastTileId } from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';
import type {
  ManagerForecastTileData,
  ManagerForecastWindowQueryRow,
} from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';

const TILE_ID_BY_WINDOW_DAYS: Record<number, ManagerForecastTileId> = {
  7: ManagerForecastTileId.Closing7,
  30: ManagerForecastTileId.Closing30,
  60: ManagerForecastTileId.Closing60,
};

const formatProspectCount = (count: number): string =>
  i18n.t(
    count === 1
      ? 'sales_portal.prospects.manager.forecast.prospect_count'
      : 'sales_portal.prospects.manager.forecast.prospect_count_plural',
    { count },
  );

export function transformToManagerForecastTiles(
  rows: ManagerForecastWindowQueryRow[],
): ManagerForecastTileData[] {
  const rowByWindowDays = new Map(rows.map((row) => [row.window_days, row]));

  return MANAGER_FORECAST_WINDOWS_IN_DAYS.map((windowDays) => {
    const row = rowByWindowDays.get(windowDays);

    return {
      id: TILE_ID_BY_WINDOW_DAYS[windowDays],
      label: i18n.t(
        'sales_portal.prospects.manager.forecast.closing_next_days',
        { count: windowDays },
      ),
      prospectCountDisplay: formatProspectCount(row?.prospect_count ?? 0),
      totalValueDisplay: row
        ? formatCurrency(row.total_value_in_micros, row.currency_code, {
            maximumFractionDigits: 0,
          })
        : EMPTY_VALUE_PLACEHOLDER,
    };
  });
}
